import angular from 'angular';
import swoaPersonDataPersonData from './person-data.component';

export default angular
  .module('swoa.person.data', [
    swoaPersonDataPersonData,
  ])
  .name;

